<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New Item </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <!-- Item Details -->
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Item Details
                  </span>
                </b-col>
              </b-row>

              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('CategoryID') }">
                    <b-form-group>
                      <label>Category</label>
                      <b-form-input
                        v-model="CategoryID"
                        type="text"
                        id="CategoryID"
                        placeholder="Category"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('CategoryID')"
                      >
                        <span style="color: red">{{
                          validation.firstError("CategoryID")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Name') }">
                    <b-form-group>
                      <label>Name</label>
                      <b-form-input
                        v-model="Name"
                        type="text"
                        id="Name"
                        placeholder="Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Name')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Name")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{ error: validation.hasError('Description') }">
                    <b-form-group>
                      <label>Description</label>
                      <b-form-textarea
                        v-model="Description"
                        type="text"
                        id="description"
                        placeholder="Description"
                      ></b-form-textarea>
                      <template
                        slot="description"
                        v-if="validation.firstError('Description')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Description")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="validateInput"
              >
                Create Item
              </b-button>
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      CategoryID: null,
      Name: null,
      Description: null,
    };
  },

  validators: {
    CategoryID(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(24)
        .maxLength(32);
    },
    Name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(120);
    },
    Description(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(50)
        .maxLength(512);
    },
  },
  methods: {
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addItem();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    addItem() {
      this.appLoading = true;
      var item = {};
      item["category_id"] = this.CategoryID;
      item["name"] = this.Name;
      item["description"] = this.Description;
      axios({
        method: "POST",
        url: "/item",
        data: item,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Items");
          } else {
            this.msg = response.data.msg;
          }
          console.log(response);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
